import addDays from 'date-fns/add_days'
import addWeeks from 'date-fns/add_weeks'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import getISODay from 'date-fns/get_iso_day'
import isBefore from 'date-fns/is_before'
import isWeekend from 'date-fns/is_weekend'
import startOfWeek from 'date-fns/start_of_week'
import subDays from 'date-fns/sub_days'

export function skipWeekends(date, originalDate) {
    if (!isWeekend(date)) {
        return date
    }

    if (date > originalDate) {
        //Get start of next week(Monday)
        return startOfWeek(addWeeks(date, 1), { weekStartsOn: 1 })
    } else {
        //Get end of previous week(Sunday) and sub 2 days
        return addDays(startOfWeek(addWeeks(date, date.getDay() === 6 ? 1 : 0)), 1)

        // return subDays(endOfWeek(subWeeks(date, date.getDay() === 0 ? 0 : 1)), 1)
    }
}

export function getRealTaskDates(startDate, endDate, originalStartDate, originalEndDate) {
    let newStartDate = startDate
    let newEndDate = endDate

    newStartDate = skipWeekends(newStartDate, originalStartDate)
    newEndDate = skipWeekends(newEndDate, originalEndDate)

    if (newEndDate < newStartDate) {
        newEndDate = newStartDate
    }

    if (newStartDate > originalEndDate) {
        newStartDate = originalEndDate
    }

    return {
        startDate: newStartDate,
        endDate: newEndDate
    }
}

export function workingDaysBetweenDates(startDate, endDate) {
    // Validate input
    if (endDate < startDate) return 0

    // Calculate days between dates
    var millisecondsPerDay = 86400 * 1000 // Day in milliseconds
    startDate.setHours(0, 0, 0, 1) // Start just after midnight
    endDate.setHours(23, 59, 59, 999) // End just before midnight
    var diff = endDate - startDate // Milliseconds between datetime objects
    var days = Math.ceil(diff / millisecondsPerDay)

    // Subtract two weekend days for every week in between
    var weeks = Math.floor(days / 7)
    days = days - weeks * 2

    // Handle special cases
    var startDay = startDate.getDay()
    var endDay = endDate.getDay()

    // Remove weekend not previously removed.
    if (startDay - endDay > 1) days = days - 2

    // Remove start day if span starts on Sunday but ends before Saturday
    if (startDay === 0 && endDay !== 6) days = days - 1

    // Remove end day if span ends on Saturday but starts after Sunday
    if (endDay === 6 && startDay !== 0) days = days - 1

    return days
}

function getWeekends(startDate, endDate) {
    var diff = Math.abs(startDate - endDate) // in milliseconds
    var ms_per_day = 1000 * 60 * 60 * 24
    var days = diff / ms_per_day + 1 // convert to days and add 1 for inclusive date range
    var mod = days % 7
    var full_weeks = (days - mod) / 7
    var weekend_days = full_weeks * 2

    if (mod !== 0) {
        // iterate through remainder days
        var startPartialWeek = new Date()
        var endPartialWeek = endDate
        startPartialWeek.setTime(endDate.getTime() - (mod - 1) * ms_per_day)
        for (var d = startPartialWeek; d <= endPartialWeek; d.setDate(d.getDate() + 1)) {
            if (d.getDay() === 0 || d.getDay() === 6) {
                weekend_days++
            }
        }
    }

    return weekend_days
}

function _getMoveDifferenceWithWeekends(date, moveDifference) {
    let weekendsToAdd =
        moveDifference < 0
            ? -(6 - getISODay(date) + Math.abs(moveDifference))
            : getISODay(date) + moveDifference - 1
    weekendsToAdd = Math.trunc(weekendsToAdd / 5) * 2
    return moveDifference + weekendsToAdd
}

function shiftFromWeekends(date, shiftIncrementally = true) {
    let result = date
    const durationInDays = shiftIncrementally ? 1 : -1

    while (isWeekend(result)) {
        result = addDays(result, durationInDays)
    }
    return result
}

function calculateDuration(moveDifference) {
    return moveDifference
}

function _getNewDateForRescheduling(moveDifference, startDate, endDate) {
    const newStartDate = getNewDateForResizing(moveDifference, startDate)

    const shiftedFromWeekendsDate = shiftFromWeekends(newStartDate)
    const rescheduledEventIsOutside = shiftedFromWeekendsDate > endDate
    if (!rescheduledEventIsOutside) {
        return shiftedFromWeekendsDate
    }

    return shiftFromWeekends(newStartDate, false)
}

function getNewDateForResizing(moveDifference, endDate) {
    const actualMoveDifference = _getMoveDifferenceWithWeekends(endDate, moveDifference)
    const duration = calculateDuration(actualMoveDifference)
    return addDays(endDate, duration)
}

const countDaysByTypeBetweenDates = (start, end, dayType) => {
    var result = 0
    var date = start

    const types = {
        workdays: [1, 2, 3, 4, 5],
        weekends: [0, 6]
    }

    while (isBefore(date, end)) {
        const dateDayType = types[dayType]
        if (dateDayType.indexOf(date.getDay()) > -1) {
            result++
        }
        date = addDays(date, 1)
    }
    return result
}

const findWorkRangeWithDuration = (date, durationInDays, forwardSearch = true) => {
    if (durationInDays === 0) {
        return { start: date, end: date }
    }
    const weekends = [0, 6]
    const days = []
    const step = 1

    let _date = date
    const incrementDays =
        (forwardSearch && durationInDays >= 0) || (!forwardSearch && durationInDays <= 0)
    while (days.length < Math.abs(durationInDays)) {
        if (weekends.indexOf(_date.getDay()) === -1) {
            incrementDays ? days.push(_date) : days.unshift(_date)
        }
        _date = incrementDays ? addDays(_date, step) : subDays(_date, step)
    }
    return { start: days[0], end: days[days.length - 1] }
}

const getWorkingDays = (start, end) => {
    return countDaysByTypeBetweenDates(start, end, 'workdays')
}

function rescheduleByStartDay(moveDifference, startDate, endDate) {
    const newStartDate = _getNewDateForRescheduling(moveDifference, startDate)

    const workingDays = getWorkingDays(startDate, endDate)
    const rangeWithDuration = findWorkRangeWithDuration(newStartDate, workingDays, true)
    return rangeWithDuration
}

export function calculateNewDates(type, date, startDate, endDate, moveDate = null, duration = 0) {
    switch (type) {
        case 'start':
            return getRealTaskDates(date, endDate, startDate, endDate)

        case 'end':
            return getRealTaskDates(startDate, date, startDate, endDate)

        case 'move':
            let offset = differenceInCalendarDays(date, moveDate)
            const weekends =
                offset > 0 ? getWeekends(moveDate, date) * -1 : getWeekends(date, moveDate)
            if (Math.abs(weekends) > 1) {
                offset += weekends
            }
            let w = rescheduleByStartDay(offset, startDate, endDate)
            return {
                startDate: w.start,
                endDate: w.end
            }

        default:
            return null
    }
}
